<div class="flex items-center justify-center h-screen">
  <div
    class="flex flex-col items-start justify-center max-w-md w-full rounded-xl p-4"
  >
    <img
      class="w-48 h-auto mx-auto mb-6"
      [ngSrc]="
        isLightMode()
          ? '../../../assets/icons/logo-j-connected_blue.png'
          : '../../../assets/icons/logo-j-connected_white.png'
      "
      height="79"
      width="190"
      alt="Johnston's Connected"
      priority
    />
    <h1 class="text-2xl">Enter verififcation code</h1>
    <p class="text-xs text-gray-400 mb-2">
      Enter the 6-digit verification code sent to your email
    </p>
    <form
      [formGroup]="verificationCodeForm"
      (ngSubmit)="onSubmit()"
      class="flex flex-col items-start justify-center max-w-md w-full rounded-xl"
    >
      <mat-form-field class="w-full">
        <mat-label>Verification Code</mat-label>
        <input
          type="number"
          matInput
          placeholder="Enter 6-digit verification code"
          formControlName="verificationCode"
        />
        @if ( verificationCodeForm.get('verificationCode')?.hasError('required')
        ) {
        <mat-error> Verification code is required. </mat-error>
        } @if (
        verificationCodeForm.get('verificationCode')?.hasError('pattern') ) {
        <mat-error> Enter the 6-digit verification code </mat-error>
        }
      </mat-form-field>
      <button
        type="submit"
        class="bg-custom-orange text-white text-md p-3 rounded-xl my-4 w-full"
      >
        Submit
      </button>
    </form>
  </div>
</div>
